var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AdFetchingStatus } from '@ads/constants';
import { fetchFwaiAds, fetchSsaiAds } from '@ads/utils/api';
import { fetchGAM } from '@ads/utils/gam';
const appendCustomVastAttrs = (adTag, vastAttrs) => {
    if (vastAttrs && !adTag.includes(vastAttrs)) {
        return adTag + vastAttrs;
    }
    return adTag;
};
export const getFWAIAds = (adUnit, params) => __awaiter(void 0, void 0, void 0, function* () {
    const xml = yield fetchGAM(appendCustomVastAttrs(adUnit.ad_tag, params === null || params === void 0 ? void 0 : params.vast_attrs));
    if (!xml) {
        return { status: AdFetchingStatus.EMPTY_VAST };
    }
    const ads = yield fetchFwaiAds({
        xml,
        params,
    });
    if (ads.length > 0) {
        return { status: AdFetchingStatus.OK, ads };
    }
    else {
        return { status: AdFetchingStatus.NO_NABOO_ADS };
    }
});
export const getSSAIAds = ({ adUnit, adConfig, appContext, params, }) => __awaiter(void 0, void 0, void 0, function* () {
    const ads = yield fetchSsaiAds({
        adUnit,
        adConfig,
        appContext,
        params,
    });
    if (ads.length > 0) {
        return { status: AdFetchingStatus.OK, ads };
    }
    else {
        return { status: AdFetchingStatus.NO_NABOO_ADS };
    }
});
export const getAdsForAdTag = ({ adUnit, adConfig, appContext, params, }) => {
    switch (true) {
        case adUnit.ad_insertion_method === 'SSAI':
            return getSSAIAds({
                adConfig,
                adUnit,
                appContext,
                params,
            });
        case adUnit.ad_insertion_method === 'FWAI':
            return getFWAIAds(adUnit, params);
        default: {
            return {
                status: AdFetchingStatus.BAD_INSERTION_METHOD,
            };
        }
    }
};
